import { SText } from '@setvi/shared/components';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { ProductInventory } from '@setvi/shared/interfaces';

export interface QuantityProps extends Omit<STextProps, 'title'> {
  row: ProductInventory;
  property:
    | 'orderedQuantity'
    | 'onOrderQuantity'
    | 'onHandQuantity'
    | 'onTransferQuantity'
    | 'availableOnHand';
}

export const Quantity = ({ row, property, ...rest }: QuantityProps) =>
  Object.prototype.hasOwnProperty.call(row, property) ? (
    <SText
      size="sm"
      lineHeight="20px"
      title={row[property].toString()}
      {...rest}
    />
  ) : (
    '-'
  );
